<div class="section section-padding sigma_service-sec style-16">
  <div class="container">
    <div class="row category-reset-container">
      <div *ngIf="!searchCriteria">Categories</div>
      <!-- TODO: reuse this if refresh button is removed the search template -->
      <!-- <div (click)="populateDrugs()">
        <i class="fa fa-undo-alt" aria-hidden="true"></i>
        Refresh
      </div> -->
    </div>
    <div class="filter-container medical-tests-section">
      <ng-container>
        <div class="profile-item">
          <div class="row ngx-slick-carousel-container filters">
            <ngx-slick-carousel
              class="profile-slider"
              [config]="slickCarouselConfig">
              <div ngxSlickItem *ngFor="let item of filterIcons; let i = index;">
                <div
                  class="sigma_service style-16"
                  [class.is-filter]="stateOfFilter?.[i]"
                  (click)="filterDrugs({category: item.title}, true, i);">
                  <div class="sigma_service-thumb"><i [class]="item.icon"></i></div>
                  <div class="sigma_service-body"><h5>{{item.title}}</h5></div>
                </div>
              </div>
            </ngx-slick-carousel>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="sigma_service-sec">
      <div class="container medical-tests-section">
        <ng-container *ngIf="drugs.length > 0">
          <div class="profile-item">
            <div class="row">
              <div 
                class="drug-col" 
                *ngFor="let drug of drugs | paginate: { itemsPerPage: itemsPerPage, currentPage: page }"
              >
                <img (click)="goToDrugDetails(drug)" [src]="drug?.images?.[0]" alt="{{ drug.name }}">
                <div class="profile-inner">
                  <div class="duration-price-container">
                    <span class="availability" [ngClass]="{'out-of-stock': selectedQuantities[drug.id]?.is_in_stock === 0 }">
                      {{ selectedQuantities[drug.id]?.is_in_stock === 1 ? 
                        'In Stock' : 'Out of Stock' }}
                    </span>
                    <span>
                      {{ selectedQuantities[drug.id]?.selling_price ? 
                        ('UGX ' + selectedQuantities[drug.id]?.selling_price) : 'Select quantity type' }}
                    </span>
                  </div>   
                  <div class="duration-price-container">
                    <a (click)="goToDrugDetails(drug)" class="primary-color">
                      <h5 class="test-title">{{ drug.name }}</h5>
                    </a>
                    <span class="price">{{ '(' + drug.country_of_origin + ')' }}</span>
                  </div>  
                  <p class="pb-0">{{ drug.description | removeHtml }}</p>
                  <div class="add-cart-buttons">
                    <!-- TODO: change selectedQuantities to selectedQuantitiesDetails-->
                    <button 
                      class="sigma_btn btn-block btn-sm mb-3" 
                      (click)="addToCart(drug, selectedQuantities[drug.id])"
                      [disabled]="selectedQuantities[drug.id]?.is_in_stock === 0"
                      [title]="selectedQuantities[drug.id]?.is_in_stock === 0 ? 'Out of stock' : ''"
                      [ngClass]="{
                        'btn-remove': ({cartItems} | buttonText: drug) === 'Remove',
                        'btn-update': ({cartItems, isDrugUpdate: isUpdateDrugQuantityType[drug.id] } | buttonText: drug) === 'Update Cart'
                      }"
                    >
                      {{ {cartItems, isDrugUpdate: isUpdateDrugQuantityType[drug.id] } | buttonText: drug }}
                    </button>
                    <div class="quantity-select-controls">
                      <select
                        [(ngModel)]="selectedQuantities[drug.id]"
                        (ngModelChange)="onQuantityTypeChange(drug.id, $event)"
                      >
                        <option [ngValue]="null" disabled>Select Quantity Type</option>
                        <option 
                          *ngFor="let qty of drug.quantity_types" 
                          [ngValue]="qty"
                        >
                          {{ qty.name }}
                        </option>
                      </select>
                      <span class="custom-arrow"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Pagination -->
          <pagination-controls (pageChange)="page = $event" [responsive]="isResponsive" previousLabel="<" nextLabel=">">
          </pagination-controls>
          <!-- Pagination -->
        </ng-container>
        <div *ngIf="drugs.length === 0" class="no-medical-tests-found">No drugs found</div>
      </div>
    </div>
  </div>
</div>
